var map = {
	"./de.json": 3211,
	"./en_GB.json": 3212,
	"./es.json": 3213,
	"./fr.json": 3214,
	"./it.json": 3215,
	"./ja.json": 3216,
	"./ko.json": 3217,
	"./nl.json": 3218,
	"./pl.json": 3219,
	"./pt_BR.json": 3220,
	"./ru.json": 3221,
	"./zh.json": 3222
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3210;